// Module
var code = "<div class=\"report-tools hide\">\n    <button class=\"remove-tool btn btn-save pull-right\" disabled=\"disabled\">Remove</button>\n</div>\n";
// Exports
module.exports = code;